import { IconDeviceDesktop } from '@tabler/icons-react';
import { ChannelType } from '@vision/ui/enums';
import { IconWithDot } from '@vision/ui/components/IconWithDot';
import {
  CustomIconCatiChannel,
  CustomIconEmailSharing,
  CustomIconGooglePlayChannel,
  CustomIconIvrChannel,
  CustomIconLinkChannel,
  CustomIconMobileChannel,
  CustomIconQrChannel,
  CustomIconQrDigitalChannel,
  CustomIconSikayetVarChannel,
  CustomIconSmsChannel,
  CustomIconWebWidgetChannel,
  CustomIconWhatsAppSharing,
} from '@vision/ui/icons';
const channelTypesWithoutDot = new Set<string>([
  ChannelType.GOOGLE_PLAY.toLowerCase(),
  ChannelType.SIKAYET_VAR.toLowerCase(),
]);

const channelTypeDotColors: Record<string, string> = {
  [ChannelType.CATI.toLowerCase()]: '#FFC32F',
  [ChannelType.IVR.toLowerCase()]: '#FFB0DD',
  [ChannelType.LINK.toLowerCase()]: '#06C494',
  [ChannelType.MOBILE.toLowerCase()]: '#c7c9d9',
  [ChannelType.DESKTOP.toLowerCase()]: '#c7c9d9',
  [ChannelType.APP_STORE.toLowerCase()]: '#B468FF',
  [ChannelType.EMAIL.toLowerCase()]: '#FF3B3B',
  [ChannelType.SMS.toLowerCase()]: '#00B7C4',
  [ChannelType.WEB_WIDGET.toLowerCase()]: '#0D7BFF',
};

function withChannelDot(icon: React.JSX.Element, size: number, dotColor: string): React.JSX.Element {
  return <IconWithDot dotColor={dotColor} dotSize={Math.round(size * 0.4)} height={size} icon={icon} width={size} />;
}

export function getChannelTypeIcon(channelType: string, size = 32): React.JSX.Element {
  const iconMap: Record<string, React.JSX.Element> = {
    [ChannelType.SMS.toLowerCase()]: <CustomIconSmsChannel width={size} height={size} />,
    [ChannelType.WEB_WIDGET.toLowerCase()]: <CustomIconWebWidgetChannel width={size} height={size} />,
    [ChannelType.WHATSAPP.toLowerCase()]: <CustomIconWhatsAppSharing width={size} height={size} />,
    [ChannelType.EMAIL.toLowerCase()]: <CustomIconEmailSharing width={size} height={size} />,
    [ChannelType.LINK.toLowerCase()]: <CustomIconLinkChannel width={size} height={size} />,
    [ChannelType.CATI.toLowerCase()]: <CustomIconCatiChannel width={size} height={size} />,
    [ChannelType.IVR.toLowerCase()]: <CustomIconIvrChannel width={size} height={size} />,
    [ChannelType.DESKTOP.toLowerCase()]: <IconDeviceDesktop size={size} />,
    [ChannelType.MOBILE.toLowerCase()]: <CustomIconMobileChannel width={size} height={size} />,
    [ChannelType.GOOGLE_PLAY.toLowerCase()]: <CustomIconGooglePlayChannel width={size} height={size} />,
    [ChannelType.SIKAYET_VAR.toLowerCase()]: <CustomIconSikayetVarChannel width={size} height={size} />,
    [ChannelType.APP_STORE.toLowerCase()]: <CustomIconQrDigitalChannel width={size} height={size} />,
    [ChannelType.KIOSK.toLowerCase()]: <CustomIconQrChannel width={size} height={size} />,
  };

  const normalizedType = channelType.toLowerCase();
  const icon = iconMap[normalizedType] || <CustomIconLinkChannel width={size} height={size} />;

  if (channelTypesWithoutDot.has(normalizedType)) {
    return icon;
  }

  return withChannelDot(icon, size, channelTypeDotColors[normalizedType] || '#06C494');
}
